// Utility function to update localStorage and dispatch event
export default function updateLocalStorage(key, value) {
  localStorage.setItem(key, value);
  window.dispatchEvent(new Event("localStorageUpdated"));
}
